import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import posthog from 'posthog-js';
import { environment } from './environments/environment';
import * as Sentry from "@sentry/angular";

// Initialize PostHog
posthog.init(
  environment.posthog_key,
  {
    api_host: environment.posthog_host
  }
);

// Initialize Sentry
Sentry.init({
  dsn: environment.sentry_dsn,
  // Setting this option to true will send default PII data to Sentry
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration(),
    Sentry.replayIntegration(),
    Sentry.feedbackIntegration({
      autoInject: false, // Don't auto-inject the feedback button
      colorScheme: "light",
      showName: false,
      isNameRequired: false,
      formTitle: "Report an Issue or Submit Feedback",
      submitButtonLabel: "Submit",
      messagePlaceholder: "Tell us about your experience or report an issue...",
      successMessageText: "Thank you for your feedback!",
      triggerLabel: "Feedback",
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of transactions
  profilesSampleRate: 1.0,
  // Set tracePropagationTargets to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/app\.anylytics\.ai/, /^https:\/\/stage\.anylytics\.ai/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // Sample 10% of sessions
  replaysOnErrorSampleRate: 1.0, // Sample 100% of sessions with errors
});
bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);